module.exports = __webpack_public_path__ + "img/tp-line.78a57932.png";